import { r4Client, r4Error } from '@/services'

const HtmlSnippetApi = {

  async fetch () {
    try {
      const resp = await r4Client().get('/api/v1/html_snippets')
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async create (snippetData) {
    try {
      const resp = await r4Client().post('/api/v1/html_snippets', snippetData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async update (snippetData) {
    try {
      const resp = await r4Client().put(`/api/v1/html_snippets/${snippetData.id}`, snippetData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  // determines if create or update should be used
  async save (snippetData) {
    if (snippetData.id) {
      return this.update(snippetData)
    } else {
      return this.create(snippetData)
    }
  },

  async get (snippetId) {
    try {
      const resp = await r4Client().get(`/api/v1/html_snippets/${snippetId}`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async getTypes () {
    try {
      const resp = await r4Client().get(`/api/v1/html_snippets/snippet_types`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async preview (snippetId, dealerId) {
    try {
      const resp = await r4Client().get(`/api/v1/html_snippets/${snippetId}/preview`, { params: { dealer_id: dealerId } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async liveview (dealerId, htmlSnippet) {
    try {
      const resp = await r4Client().post('/api/v1/html_snippets/liveview', { template: htmlSnippet, dealer_id: dealerId })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async delete (snippetId) {
    throw r4Error('not implemented')
  }

}

export default HtmlSnippetApi
